import dayjs from 'dayjs';
import Model from '../models/model';
import consts from '../consts';
import util from '../util';
import { dataStore } from '../Store';

const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}

const checkIsParametric = () => isparametric()
const checkIsNotParametric = () => !isparametric()
const { renderAttachmentButton } = util;
const model = new Model({
	name: 'Cycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	title: "EndoWasher Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: "CycleName", width: 200 },
		{ field: 'CycleCount', header: "CycleCount", width: 150 },
		{ field: 'CycleStatus', header: "SterCycleStatus", width: 200 },
		{ field: 'CycleStart', header: "CycleDateTime", width: 200, type: 'dateTime' },
		{ field: 'ModelNumber', header: "DeviceModel", width: 150, valueFormatter: util.removecommas },
		{ field: 'InstrumentName', header: "DeviceId", width: 150, valueFormatter: util.removecommas },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 150 },
		{ field: 'Label', header: "Label", width: 150 },
		{ field: 'OperatorName', header: "OperatorName", width: 150 },
		{ field: 'UnloadOperatorName', header: "UnloadOperatorName", width: 150, valueFormatter: util.removecommas },
		{ field: 'UnloadOperatorID', header: "UnloadOperatorID", width: 150, valueFormatter: util.removecommas },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row)), filterable: false, isNotExportField: true },
		{ field: 'CycleActionStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewDate', header: "ApprovedOn", width: 150, type: 'dateTime', isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewByUser', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'EndoscopeTopName', header: "EndoscopeTopName", width: 150, valueFormatter: util.removecommas },
		{ field: 'EndoscopeBottomName', header: "EndoscopeBottomName", width: 150, valueFormatter: util.removecommas },
		{ field: 'EndoscopeSerialNumberTop', header: "EndoscopeSerialNumberTop", width: 150, valueFormatter: util.removecommas },
		{ field: 'EndoscopeModelTop', header: "EndoscopeModelTop", width: 150, valueFormatter: util.removecommas },
		{ field: 'EndoscopeModelBottom', header: "EndoscopeModelBottom", width: 150, valueFormatter: util.removecommas },
		{ field: 'ItemRefNumberTop', header: "TopOrderNumber", width: 150, valueFormatter: util.removecommas },
		{ field: 'ItemRefNumberBottom', header: "BottomOrderNumber", width: 150, valueFormatter: util.removecommas },
		{
			field: 'endoWasherSearch',
			header: 'Search',
			type: 'string',
			hide: true,
			headerFilter: true,
			standaloneHeaderFilter: true,
			isNotFormfield: true,
			placeholder: 'Operator Name Endoscope Serial Number Top/Bottom Endoscope Name Top/Bottom'
		},
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A1'
		}
	}
});

export const EndoWasherTable = model;
export default model.createFormBase();
